import { Theme } from '@mui/material/styles'
import { TUserStatus } from 'src/services/auth/users'

export const getStatusColor = (theme: Theme, status?: TUserStatus | null) => {
  switch (status) {
    case 'online':
      return theme.palette.success.main
    case 'away':
      return theme.palette.warning.main
    case 'dnd':
      return theme.palette.error.main
    default:
      return theme.palette.grey[400]
  }
}
